var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Packer_buffer, _Packer_view, _Packer_offset, _Unpacker_view, _Unpacker_offset;
import { Game } from './game';
import * as PPMd from "./compressor";
import { PatchMap, TileMap } from './tile';
import { stringToCodePoints } from './util';
export class Packer {
    constructor(compressor) {
        _Packer_buffer.set(this, void 0);
        _Packer_view.set(this, void 0);
        _Packer_offset.set(this, void 0);
        __classPrivateFieldSet(this, _Packer_buffer, new ArrayBuffer(10240), "f");
        __classPrivateFieldSet(this, _Packer_view, new DataView(__classPrivateFieldGet(this, _Packer_buffer, "f")), "f");
        __classPrivateFieldSet(this, _Packer_offset, 0, "f");
        this.compressor = compressor;
    }
    getUint8Array() {
        return new Uint8Array(__classPrivateFieldGet(this, _Packer_buffer, "f"), 0, __classPrivateFieldGet(this, _Packer_offset, "f"));
    }
    packUint8(value) {
        __classPrivateFieldGet(this, _Packer_view, "f").setUint8(__classPrivateFieldGet(this, _Packer_offset, "f"), value);
        __classPrivateFieldSet(this, _Packer_offset, __classPrivateFieldGet(this, _Packer_offset, "f") + 1, "f");
    }
    packUint16(value) {
        __classPrivateFieldGet(this, _Packer_view, "f").setUint16(__classPrivateFieldGet(this, _Packer_offset, "f"), value);
        __classPrivateFieldSet(this, _Packer_offset, __classPrivateFieldGet(this, _Packer_offset, "f") + 2, "f");
    }
    packUintVar(value) {
        do {
            let piece = value & 127;
            value = value >> 7;
            if (value > 0) {
                piece += 128;
            }
            this.packUint8(piece);
        } while (value > 0);
    }
    packString(value) {
        const encoded = new TextEncoder().encode(value);
        this.packUint8Array(encoded);
    }
    packUint8Array(value) {
        value = this.compressor(value);
        this.packUintVar(value.byteLength);
        for (const val of value) {
            this.packUint8(val);
        }
    }
}
_Packer_buffer = new WeakMap(), _Packer_view = new WeakMap(), _Packer_offset = new WeakMap();
export class Unpacker {
    constructor(data, decompressor) {
        _Unpacker_view.set(this, void 0);
        _Unpacker_offset.set(this, void 0);
        __classPrivateFieldSet(this, _Unpacker_view, new DataView(data.buffer, data.byteOffset, data.byteLength), "f");
        __classPrivateFieldSet(this, _Unpacker_offset, 0, "f");
        this.decompressor = decompressor;
    }
    unpackUint8() {
        const value = __classPrivateFieldGet(this, _Unpacker_view, "f").getUint8(__classPrivateFieldGet(this, _Unpacker_offset, "f"));
        __classPrivateFieldSet(this, _Unpacker_offset, __classPrivateFieldGet(this, _Unpacker_offset, "f") + 1, "f");
        return value;
    }
    unpackUint16() {
        const value = __classPrivateFieldGet(this, _Unpacker_view, "f").getUint16(__classPrivateFieldGet(this, _Unpacker_offset, "f"));
        __classPrivateFieldSet(this, _Unpacker_offset, __classPrivateFieldGet(this, _Unpacker_offset, "f") + 2, "f");
        return value;
    }
    unpackUintVar() {
        let value = 0;
        let multiplier = 1;
        let piece = 0;
        do {
            piece = this.unpackUint8();
            value += (piece & 127) * multiplier;
            multiplier *= 128;
        } while (piece > 127);
        return value;
    }
    unpackString() {
        const value = this.unpackUint8Array();
        return new TextDecoder().decode(value);
    }
    unpackUint8Array() {
        const byteLength = this.unpackUintVar();
        let value = new Uint8Array(byteLength);
        for (let i = 0; i < byteLength; i++) {
            value[i] = this.unpackUint8();
        }
        return this.decompressor(value);
    }
}
_Unpacker_view = new WeakMap(), _Unpacker_offset = new WeakMap();
// Import/Export
// https://stackoverflow.com/a/12713326
export function urlToData() {
    const params = new URLSearchParams(window.location.search);
    const base64 = params.get("s");
    if (base64 === null)
        return null;
    const compressed = Uint8Array.from(atob(base64), (m) => { var _a; return (_a = m.codePointAt(0)) !== null && _a !== void 0 ? _a : 0; });
    if (compressed.length === 0)
        return null;
    return compressed;
}
export function dataToUrl(data, page) {
    const base64 = btoa(Array.from(data, (byte) => String.fromCodePoint(byte)).join(""));
    const params = new URLSearchParams();
    params.set("s", base64);
    return window.location.origin + "/" + page + "?" + params;
}
export function packGame(game, compressor = PPMd.compress) {
    const packer = new Packer(compressor);
    // Info
    packer.packString(game.metadata.title);
    packer.packString(game.metadata.description);
    // Script
    packer.packString(game.script);
    // Tilemap
    packer.packUintVar(game.tileMap.dim.w);
    packer.packUintVar(game.tileMap.dim.h);
    packer.packUintVar(game.tileMap.count);
    const codePoints = [];
    const colours = [];
    for (const data of game.tileMap.tileData) {
        codePoints.push(...data.codePoint);
        colours.push(...data.colour);
    }
    packer.packString(String.fromCodePoint(...codePoints));
    packer.packUint8Array(Uint8Array.from(colours));
    // Patch Map
    packer.packUintVar(game.patchMap.dim.w);
    packer.packUintVar(game.patchMap.dim.h);
    packer.packUint8Array(Uint8Array.from(game.patchMap.tileData.patchId));
    packer.packUint8Array(Uint8Array.from(game.patchMap.tileData.transform));
    // Markers
    packer.packUintVar(game.markers.length);
    for (const marker of game.markers) {
        packer.packUintVar(marker.x);
        packer.packUintVar(marker.y);
        packer.packUintVar(marker.codePoint);
    }
    // Solid Tiles
    packer.packString(String.fromCodePoint(...game.solidTiles));
    return packer.getUint8Array();
}
export function unpackGame(data, decompressor = PPMd.decompress) {
    const unpacker = new Unpacker(data, decompressor);
    // Info
    const infoTitle = unpacker.unpackString();
    const infoDescription = unpacker.unpackString();
    // Script
    const script = unpacker.unpackString();
    // Tilemap
    const tileMapDimW = unpacker.unpackUintVar();
    const tileMapDimH = unpacker.unpackUintVar();
    const tileMapCount = unpacker.unpackUintVar();
    const tileMapCodePoints = stringToCodePoints(unpacker.unpackString());
    const tileMapColours = unpacker.unpackUint8Array();
    const tileMap = new TileMap({ w: tileMapDimW, h: tileMapDimH }, tileMapCount);
    const patchSize = tileMapDimW * tileMapDimH;
    for (let p = 0; p < tileMapCount; p++) {
        tileMap.tileData[p].codePoint = tileMapCodePoints.slice(patchSize * p, patchSize * (p + 1));
        tileMap.tileData[p].colour = [...tileMapColours.slice(patchSize * p, patchSize * (p + 1))];
    }
    // Patch Map
    const patchMapDimW = unpacker.unpackUintVar();
    const patchMapDimH = unpacker.unpackUintVar();
    const patchMapPatchIds = unpacker.unpackUint8Array();
    const patchMapTransforms = unpacker.unpackUint8Array();
    const patchMap = new PatchMap({ w: patchMapDimW, h: patchMapDimH });
    patchMap.tileData.patchId = [...patchMapPatchIds];
    patchMap.tileData.transform = [...patchMapTransforms];
    // Markers
    const markerLength = unpacker.unpackUintVar();
    const markers = [];
    for (let i = 0; i < markerLength; i++) {
        markers.push({
            x: unpacker.unpackUintVar(),
            y: unpacker.unpackUintVar(),
            codePoint: unpacker.unpackUintVar(),
        });
    }
    // Solid tiles
    const tileMapSolidTiles = unpacker.unpackString();
    let game = new Game({ title: infoTitle, description: infoDescription }, script, tileMap, patchMap);
    game.markers = markers;
    game.solidTiles = stringToCodePoints(tileMapSolidTiles);
    return game;
}
export function urlToGame() {
    let urlData = urlToData();
    if (urlData === null) {
        return new Game();
    }
    return unpackGame(urlData);
}
export function gameToUrl(game, page = "play") {
    return dataToUrl(packGame(game), page);
}
